module.exports = __webpack_public_path__ + "static/media/404-illustration.24285cb3.png";